import { type PropsWithChildren, useState } from 'react';

import Tippy from '@tippyjs/react';

import { useTheme } from '@/_shared/styles/theme/use-theme';

import type { TooltipProps } from './types';

const placements = {
  // default
  top: '',
  'top-start': 'rounded-bl-none',
  'top-end': 'rounded-br-none',

  right: '',
  'right-start': 'rounded-tl-none',
  'right-end': 'rounded-bl-none',

  bottom: '',
  'bottom-start': 'rounded-tl-none',
  'bottom-end': 'rounded-tr-none',

  left: '',
  'left-start': 'rounded-tr-none',
  'left-end': 'rounded-br-none',
};

export function Tooltip({
  children,
  disabled,
  placement = 'top',
  className,
  zIndex,
  ...props
}: PropsWithChildren<TooltipProps>) {
  const { text } = useTheme();
  const [reference, setReference] = useState<HTMLDivElement | null>(null);

  if (disabled) {
    return children || null;
  }

  return (
    <>
      <div ref={setReference}>{children}</div>
      <Tippy
        {...props}
        reference={reference}
        offset={[0, 4]}
        duration={50}
        zIndex={zIndex ?? 2}
        placement={placement}
        className={`${className} ${
          placements[placement as keyof typeof placements]
        } text-c-card-muted shadow-card border-c-border-muted bg-c-card rounded-md border px-2 py-1 ${text.tooltip}`}
      />
    </>
  );
}
